import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_hkhwuqw7vy: FaireCollectionEntity = {
  token: "pbc_hkhwuqw7vy",
  type: "collection",
  name: "Fall 🍁🍂",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b6ee616ce8196487494b2e108af4a3208a095066d6891b2eaa771281201e1409.jpeg",
  itemCount: 50,
  description: "Twirl into Autumn because Fall is here!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.997Z",
    importedBy: "entity-db-import-collections",
  },
};
